import React from "react";

const SellmodeIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="47" height="47" rx="10.1667" fill="white" />
      <rect
        x="0.5"
        y="0.5"
        width="47"
        height="47"
        rx="10.1667"
        stroke="#D1EFDD"
      />
      <path
        d="M34.7039 19.8L32.6387 14.4H27.7032L28.6512 20.6904C28.836 21.8784 30.1356 22.8 31.7147 22.8C33.4187 22.8 34.7999 21.7248 34.7999 20.4C34.7999 20.1912 34.7663 19.992 34.7039 19.8Z"
        fill="#19AE57"
      />
      <path
        d="M24 22.8C25.704 22.8 27.0852 21.7248 27.0852 20.4C27.0852 20.362 27.083 20.3241 27.0809 20.2872L27.0792 20.2548L26.4684 14.4H21.5316L20.9196 20.25C20.9172 20.2992 20.9148 20.3484 20.9148 20.4C20.9148 21.7248 22.296 22.8 24 22.8Z"
        fill="#A3DFBC"
      />
      <path
        d="M19.3476 20.7L20.2968 14.4H15.36L13.2972 19.8C13.2336 19.992 13.2 20.1912 13.2 20.4C13.2 21.7248 14.58 22.8 16.2852 22.8C17.8572 22.8 19.1568 21.8832 19.3476 20.7Z"
        fill="#19AE57"
      />
      <path
        d="M30 24.0552V28.8H18V24.0624C17.4744 24.252 16.896 24.36 16.2852 24.36C16.0512 24.36 15.8244 24.3324 15.6 24.3012V31.92C15.6 32.844 16.3548 33.6 17.2776 33.6H30.72C31.6439 33.6 32.3999 32.8428 32.3999 31.92V24.3024C32.1731 24.3372 31.9442 24.3569 31.7147 24.3612C31.1296 24.3606 30.5492 24.257 30 24.0552Z"
        fill="#696677"
      />
      <path
        d="M26.8313 20.3009L26.8313 20.3013C26.8335 20.3393 26.8352 20.3702 26.8352 20.4C26.8352 21.532 25.6279 22.55 24 22.55C22.372 22.55 21.1648 21.532 21.1648 20.4C21.1648 20.3575 21.1667 20.3162 21.169 20.2691L21.7568 14.65H26.2431L26.8299 20.2746L26.8313 20.3009ZM30 29.05H30.25V28.8V24.4007C30.7251 24.5396 31.2182 24.6107 31.7145 24.6112V24.6112L31.7195 24.6111C31.8633 24.6084 32.0069 24.6 32.1499 24.5858V31.92C32.1499 32.7048 31.5058 33.35 30.72 33.35H17.2776C16.4932 33.35 15.85 32.7062 15.85 31.92V24.5846C15.9906 24.5996 16.1359 24.61 16.2852 24.61C16.7986 24.61 17.2906 24.5372 17.75 24.4057V28.8V29.05H18H30ZM27.9937 14.65H32.4667L34.4681 19.8831C34.5215 20.0495 34.5499 20.2208 34.5499 20.4C34.5499 21.532 33.3427 22.55 31.7147 22.55C30.2122 22.55 29.0581 21.6773 28.8983 20.6525C28.8982 20.6523 28.8982 20.6522 28.8982 20.652L27.9937 14.65ZM20.0063 14.65L19.1006 20.6615C18.9351 21.6822 17.7803 22.55 16.2852 22.55C14.6561 22.55 13.45 21.532 13.45 20.4C13.45 20.2206 13.4785 20.0496 13.5328 19.8838L15.5321 14.65H20.0063Z"
        stroke="black"
        strokeWidth="0.5"
      />
    </svg>
  );
};

export default SellmodeIcon;
